import sharedEmailFieldType from '../../shared/field-types/email';
import textBoxFieldType from './textBox';

export default {
	...textBoxFieldType,
	...sharedEmailFieldType
};
